import { render, staticRenderFns } from "./SH011ShopperLogin.vue?vue&type=template&id=53056412&"
import script from "./SH011ShopperLogin.vue?vue&type=script&lang=js&"
export * from "./SH011ShopperLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports